import React from "react";
import { Box } from "@mui/material";
import ProjectSection from "../components/ProjectSection";
import SEO from "../components/SEO";

const PROJECTS_SCHEMA = {
  "@context": "https://schema.org",

  "@graph": [
    {
      "@type": "CollectionPage",

      "@id":
        "https://studio.wiyoutech.in/projects#page",

      "name":
        "Featured Projects & Web Portfolio | WiYou! Tech Studios",

      "description":
        "Explore custom web applications, responsive business websites, and digital products engineered by WiYou! Tech Studios in Jaipur, Rajasthan.",

      "url":
        "https://studio.wiyoutech.in/projects",

      "isPartOf": {
        "@type": "WebSite",
        "@id":
          "https://studio.wiyoutech.in/#website",
      },
    },

    {
      "@type": "ItemList",

      "name":
        "Featured Production Projects",

      "itemListElement": [
        {
          "@type": "ListItem",

          "position": 1,

          "item": {
            "@type":
              "SoftwareApplication",

            "name":
              "BunkMates",

            "applicationCategory":
              "TravelApplication",

            "operatingSystem":
              "Web, PWA",

            "url":
              "https://bunkmates.xyz",

            "description":
              "A comprehensive group travel management ecosystem featuring real-time trip planning, expense tracking, messaging, offline PWA capabilities, and an administrative analytics panel.",
          },
        },

        {
          "@type": "ListItem",

          "position": 2,

          "item": {
            "@type":
              "WebSite",

            "name":
              "ANVI Library & Apartments",

            "url":
              "https://anvi-library-apartment.vercel.app/",

            "description":
              "A full-featured web platform and administrative CMS for managing property amenities, student library facilities, bookings, and digital operations.",
          },
        },

        {
          "@type": "ListItem",

          "position": 3,

          "item": {
            "@type":
              "WebSite",

            "name":
              "J. Alex Salon Web",

            "url":
              "https://j-alex-salon.vercel.app/",

            "description":
              "A premium responsive salon website designed for J. Alex Salon, showcasing bridal makeup, beauty services, hair styling, cinematic beauty reels, salon information, and appointment booking experiences.",
          },
        },
      ],
    },
  ],
};


const Projects = () => (
  <Box sx={{ mt: 10, p: { xs: 2, md: 3 }, textAlign: "center" }}>
    <SEO
      title="Web Development & Design Projects | WiYou! Tech Studios Jaipur"
      description="Explore production web applications, business platforms, and digital designs engineered by WiYou! Tech Studios in Jaipur, Rajasthan. Real client work and verified results."
      keywords={[
        "web development projects Jaipur",
        "web design portfolio Jaipur",
        "custom web applications Jaipur",
        "WiYou Tech Studios portfolio",
        "business website portfolio India",
        "progressive web app portfolio"
      ]}
      canonicalUrl="https://studio.wiyoutech.in/projects"
      schema={PROJECTS_SCHEMA}
    />
    <ProjectSection />
  </Box>
);

export default Projects;

